import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { bindActionCreators } from 'redux';

import { getFileDownload, resetFileDownload } from './reducer';

class FileDownload extends Component {
  componentDidUpdate() {
    const { resetFileDownload } = this.props;

    setTimeout(() => {
      resetFileDownload();
    }, 1000);

    if (this.form) {
      this.form.submit();
    }
  }

  renderFormInputs = (queryParams) => {
    return Object.keys(queryParams).map((name, index) => {
      return (
        <input
          key={index}
          name={name}
          type="hidden"
          value={queryParams[name]}
        />
      );
    });
  };

  render() {
    const { fileDownload } = this.props;
    const { actionPath, method, queryParams } = fileDownload;

    if (isEmpty(queryParams)) {
      return null;
    }

    return (
      <form
        ref={(ref) => { this.form = ref; }}
        action={actionPath}
        method={method}
        style={{ display: 'none' }}
      >
        {this.renderFormInputs(queryParams)}
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    fileDownload: getFileDownload(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    resetFileDownload,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(FileDownload);



// WEBPACK FOOTER //
// ./src/components/ui/FileDownload/index.js